module.exports = __webpack_public_path__ + "img/icon_floating_chatbot.0e0686e9.svg";